import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SearchBarState {
    isOpen: boolean;
    isSubsectionOpen: boolean;
    isSearchForHome: boolean;
    overrideNoHomeRedirect: boolean;
}

const initialState: SearchBarState = {
    isOpen: false,
    isSubsectionOpen: false,
    isSearchForHome: false,
    overrideNoHomeRedirect: false,
};

const searchBarSlice = createSlice({
    name: 'searchBar',
    initialState,
    reducers: {
        showSearchBar: (state) => {
            state.isOpen = true;
            state.isSubsectionOpen = true;
        },
        hideSearchBar: (state) => {
            state.isOpen = false;
            state.isSubsectionOpen = false;
            state.isSearchForHome = false;
        },
        setSearchForHome: (state) => {
            state.isOpen = true;
            state.isSearchForHome = true;
        },
        setOverrideNoHomeRedirect: (state, action: PayloadAction<boolean>) => {
            state.overrideNoHomeRedirect = action.payload;
        },
        showSubsection: (state) => {
            state.isSubsectionOpen = true;
        },
    },
});

export const {
    showSearchBar,
    hideSearchBar,
    setSearchForHome,
    setOverrideNoHomeRedirect,
    showSubsection
} = searchBarSlice.actions;
export default searchBarSlice.reducer;
